import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Badge, Button } from 'react-bootstrap';
import DOMPurify from 'dompurify';
import SingleDetailHeader from '../../components/singleDetail/SingleDetailHeader';
import BreadCrumb from '../../components/breadcrumb/BreadCrumb';

const BlogItem = () => {
  const { blogId } = useParams(); 
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const [blogData, setBlogData] = React.useState({
    title: '',
    author: '',
    publish_date: '',
    image_url: '',
    excerpt: '',
    introduction: '',
    main_content: '',
    conclusion: '',
    tags: [],
    meta_title: '',
    meta_description: '',
  });

  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = React.useState(false);
  // eslint-disable-next-line no-unused-vars
  const [isError, setIsError] = React.useState(false);

  const formatDate = (dateArray) => {
    const [year, month, day] = dateArray;
    const date = new Date(year, month - 1, day);
    return date.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };
  // Fetch blog data by ID
  const fetchBlogData = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${baseUrl}/all/blogs/${blogId}`);
      if (response.status === 200) {
        const data = response.data.blog;
        setBlogData({
          title: data.title,
          author: data.author,
          publish_date: formatDate(data.publish_date),
          image_url: data.image_url,
          excerpt: data.excerpt,
          introduction: data.content,
          tags: data.tags.split(','), // tags are comma separated
          meta_title: data.meta_title,
          meta_description: data.meta_description,
        });
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blogId]);

  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "Master", link: "/user" },
    { label: "Blog", link: "/blog" },
    { label: "Blog Detail", link: "", active: true },
  ];

  return (
    <Container>
      <BreadCrumb items={breadcrumbItems} />
      <Row className="justify-content-center">
        <Col lg={12} md={12} sm={12}>
          <SingleDetailHeader header={"Blog Details"}/>
          <Card border="0" className="shadow-lg p-4">
            <div className="text-center mb-4">
              <h1 className="fw-bold mb-3">{blogData.title || 'Loading...'}</h1>
              <p className="text-muted mb-1">
                By <strong>{blogData.author || 'Unknown'}</strong> |{' '}
                <small>Published on {blogData.publish_date || '-'}</small>
              </p>
              {blogData.image_url && (
                // eslint-disable-next-line jsx-a11y/img-redundant-alt
                <img
                  src={blogData.image_url}
                  alt="Blog Image"
                  className="img-fluid rounded-4 mt-4"
                  style={{ maxHeight: '400px', objectFit: 'cover' }}
                />
              )}
            </div>

            <div>
              <p className="lead fst-italic">{blogData.excerpt || 'Excerpt loading...'}</p>
            </div>

            <div className="py-4">
              <h2 className="text-primary">Introduction</h2>
              <div 
                dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blogData.introduction || 'Introduction loading...') }}
              />
            </div>

            <div className="pt-4 border-top">
              <p className="mb-1">
                <strong className='pe-3'>Tags:</strong>
                {blogData.tags.length > 0 ? (
                  blogData.tags.map((tag, index) => (
                    <Badge key={index} bg="primary" className="me-1">
                      {tag}
                    </Badge>
                  ))
                ) : (
                  <span>No tags available</span>
                )}
              </p>
              <small className="text-muted">
                Meta Title: {blogData.meta_title || 'No meta title'} | Meta Description: {blogData.meta_description || 'No description'}
              </small>
            </div>

            
          </Card>
          <div className="mt-4 pb-4">
            <Link to="/blog">
              <Button variant="primary">Back</Button>
            </Link>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default BlogItem;
